import { FormGroup } from '@angular/forms';

export function getFormData(formGroup: FormGroup): FormData {
  const formData = new FormData();

  // Iterate through form controls
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);

    // Check if the control is a file input
    if (control instanceof FileList) {
      for (let i = 0; i < control?.length!; i++) {
        formData.append(key, control?.item(i)!);
      }
    } else {
      formData.append(key, control?.value);
    }
  });

  return formData;
}

export function logFormData(formData: FormData): void {
  console.log('FormData Content:');
  formData.forEach((value, key) => {
    console.log(key + ':', value);
  });
}

export function logFormDataEntries(formData: FormData) {
  for (const [key, value] of (formData as any).entries()) {
    console.log(`${key}:`, value);
  }
}


// export function logFormDataEntries(formData: FormData) {
//   for (const [key, value] of formData.entries()) {
//     console.log(`${key}:`, value);
//   }
// }

export function logFormDataPretty(formData: FormData) {
  const obj: Record<string, any> = {};

  for (const [key, value] of (formData as any).entries()) {
    if (value instanceof File) {
      obj[key] = {
        fileName: value.name,
        fileSize: value.size,
        fileType: value.type
      };
    } else {
      obj[key] = value;
    }
  }

  console.log("FormData Contents:", JSON.stringify(obj, null, 2));
}

// export function logFormDataPretty(formData: FormData) {
//   const obj: Record<string, any> = {};

//   for (const [key, value] of formData.entries()) {
//     if (value instanceof File) {
//       obj[key] = {
//         fileName: value.name,
//         fileSize: value.size,
//         fileType: value.type
//       };
//     } else {
//       obj[key] = value;
//     }
//   }

//   console.log("FormData Contents:", JSON.stringify(obj, null, 2));
// }

export function convertBooleanToYesNo(val: boolean | null): 'yes' | 'no' | null {
  return (val!=null? val===true? 'yes': 'no' : null)
}

export function convertYesNoToBoolean(val: string | null): boolean | null {
  if (val == 'yes')
    return true;
  else if (val == 'no')
    return false;

  return null;
}

export function convertYesNoToBooleanString(val: string | null): string {
  if (val == 'yes')
    return 'true';
  else if (val == 'no')
    return 'false';

  return '';
}